module.exports = __webpack_public_path__ + "media/img/decorations/why-work-right-img-7d0f391dcfc5b9a62319fc6f64c18050.svg";